import styled from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';

export const StyledWrapper = styled.div`
  padding: ${rem(16)} 0;
`;

export const StyledInfoBox = styled.div`
  padding: ${rem(16)};
  background: ${variables.colors.highlightBg};
  word-break: break-word;
  border-radius: ${rem(4)};
  margin-bottom: ${rem(20)};
`;

export const StyledLinkWrapper = styled.div`
  margin-top: ${rem(10)};
`;
